import React from "react";
import "../../css/style.css";
import CommonHeading from "../common/CommonHeading";
import { facility, roomItems } from "../data/Data";
import { useEffect, useState } from "react";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { RiFridgeLine } from "react-icons/ri";
import { FaWater } from "react-icons/fa";
import { TbAirConditioning } from "react-icons/tb";
import { CiWifiOn } from "react-icons/ci";
import { MdOutlineFreeBreakfast } from "react-icons/md";
import { PiTelevisionSimpleThin } from "react-icons/pi";
import { PiBuildingApartmentLight } from "react-icons/pi";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { LuBedDouble, LuBedSingle } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import Heading from "../common/Heading";

export default function Rooms() {
  const navigate = useNavigate();
  const [roomData, setRoomData] = useState([]);
  // Map string names to icon components
  const iconMapping = {
    LiaRupeeSignSolid,
    RiFridgeLine,
    FaWater,
    TbAirConditioning,
    CiWifiOn,
    MdOutlineFreeBreakfast,
    PiTelevisionSimpleThin,
    PiBuildingApartmentLight,
    FaIndianRupeeSign,
    LuBedDouble,
    LuBedSingle,
  };
  useEffect(() => {
    fetch("https://api.bgmhotel.com/rooms/", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        setRoomData(json);
        console.log("json====room back", json);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  return (
    <>
      {/* heading="Our Rooms" title="Rooms" subtitle="Explore Our" */}
      {/* <div className="banner">
        <div
          className="col-12 bg-dark text-white jumbotron"
          style={{ height: "25rem", top: "50%" }}
        >
          <div className=" text-center overflow-hidden text-overlay">
            <div className="text-style">
              <h6 className="section-title text-white text-uppercase mb-3 animated slideInDown">
                With The Best Prices
              </h6>
              <h3 className="display-3 text-white mb-4 animated slideInDown">
                <span>Book Your Rooms</span>
              </h3>
            </div>
          </div>
        </div>
      </div> */}
      <Heading heading="Rooms" title="Home" subtitle="Room" />
      {/* <div className="container py-5"> */}
      <div className="container py-5">
        <div className="">
          <div className="py-2">
            <h6 className="">
              The BGM HOTEL serves a buffet carte breakfast and breakfast in the
              room is also available.
            </h6>
            <p>
              BGM HOTEL offers rooms with air conditioning and a private
              bathroom in Giloth. There is an on-site restaurant, plus free
              private parking and free WiFi are available. The accommodation
              provides a 24-hour front desk, a lift and luggage storage for
              guests.
            </p>
          </div>
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title text-center text-warning text-uppercase">
              Our Rooms
            </h6>
            <h1 className="mb-5">
              Explore Our
              <span className="text-warning text-uppercase"> Rooms</span>
            </h1>
          </div>
          <div className="col-12 justify">
            <h6>Discover Comfort and Luxury at BGM Hotel & Restaurant</h6>
            <p>
              Looking for the perfect room for your stay? At BGM Hotel &
              Restaurant, we offer a variety of elegantly designed rooms that
              cater to your every need. Whether you're traveling for business,
              celebrating a special occasion, or simply taking a break, our
              accommodations provide the ideal blend of comfort and
              sophistication. From cozy single rooms to spacious suites, each
              space is thoughtfully equipped to ensure your stay is nothing
              short of perfect.
            </p>

            <p>
              Our rooms feature modern amenities such as high-speed WiFi, plush
              bedding, and stunning views. Wake up to the soothing ambiance of
              Your Area and enjoy the luxury of personalized service. After a
              long day, unwind in the tranquility of your room or indulge in our
              relaxing spa and wellness services, ensuring you feel rejuvenated
              throughout your stay.
            </p>
          </div>
          <h6 className="text-center text-warning text-uppercase py-4">
            <u>Available Rooms</u>
          </h6>
          <div className="row g-4">
            {roomData.map((datanew, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay="0.1s"
              >
                <div className="room-item shadow  overflow-hidden">
                  <div className="position-relative">
                    <img
                      className="img-fluid"
                      src={`https://api.bgmhotel.com${datanew.mainImage?.url}`}
                      alt="img"
                    />
                    <small className="position-absolute start-0 top-100 translate-middle-y bg-primary text-white  py-1 px-3 ms-4">
                      {iconMapping[datanew.price.icon] ? (
                        React.createElement(iconMapping[datanew.price.icon], {})
                      ) : (
                        <span>{datanew.price.icon}</span>
                      )}
                      {datanew.price.label} / Night
                    </small>
                  </div>
                  <div className="p-4 mt-2">
                    <div className="d-flex justify-content-between mb-3">
                      <h5 className="mb-0">{datanew.roomType}</h5>
                    </div>
                    <div className="d-flex mb-3">
                      {datanew.facilities.map((facility, indexFaci) => (
                        // <label className="text-center p-2" key={indexFaci}>
                        <small className="border-end me-3 pe-3" key={indexFaci}>
                          {iconMapping[facility.icon] ? (
                            React.createElement(iconMapping[facility.icon], {})
                          ) : (
                            <span>{facility.icon} | </span>
                          )}
                        </small>
                      ))}
                    </div>
                    {/* <p className="text-body mb-3">{datanew.description}</p> */}
                    <p className="text-body mb-3 py-2">
                      At BGM Hotel & Restaurant, we understand that every guest
                      is unique. That's why we offer a range of packages and
                      services tailored to your preferences.
                    </p>
                    <div className="d-flex justify-content-between">
                      {/* <a
                        className="btn btn-primary-custom  py-2 px-4"
                        href=""
                      >
                        View Detail
                      </a> */}

                      <button
                        className="btn btn-primary-custom  py-2 px-4 animated slideInLeft"
                        onClick={() => navigate(`/rooms/${datanew.id}`)}
                      >
                        View Detail
                      </button>
                      <button
                        className="btn btn-dark-custom  py-2 px-4 animated slideInRight"
                        onClick={() => navigate(`/rooms/${datanew.id}/booking`)}
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="col-12 container py-5 justify">
        <p>
          Booking with us is easy and hassle-free. Whether you're planning a
          quick getaway or an extended stay, our dedicated team is here to
          assist you every step of the way. Simply let us know your preferences,
          and we'll tailor your experience to match your needs. Planning
          something special? We'll be happy to add personalized touches to make
          your visit even more memorable.
        </p>
        <p>
          Don't miss the chance to explore our on-site restaurant, where
          culinary delights await. Start your day with a hearty breakfast, enjoy
          a leisurely lunch, or savor a gourmet dinner prepared by our expert
          chefs. Pair your meal with a fine wine or a crafted cocktail, and let
          us take your dining experience to the next level.
        </p>
        <p>
          Ready to book your stay? Let BGM Hotel & Restaurant be your home away
          from home. Contact us today and reserve your room - we can't wait to
          welcome you and make your stay unforgettable!
        </p>
      </div>
    </>
  );
}
